module.exports = __webpack_public_path__ + "static/img/indexSite.cb569639.png";